/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdDialogProps } from './type';

export const dialogDefaultProps: TdDialogProps = {
  buttonLayout: 'horizontal',
  closeBtn: false,
  closeOnOverlayClick: false,
  destroyOnClose: false,
  overlayProps: {},
  preventScrollThrough: true,
  showOverlay: true,
};
